<div class="cover-section">
  <div class="text-center">
    <img class="img-fluid" src="assets/images/no_product_available.png" alt="no-blog-img">
    <h1>Stay Tuned</h1>
    <h4>Currently no Content available on this page. Coming soon…</h4>
  </div>
</div>

